var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtmlCssJs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 48,
    viewBox: "0 0 53 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3333 3.33331H4.66667L6.66667 26L16 28.6666L25.3333 26L27.3333 3.33331Z",
    fill: "#E65100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.33334V26.6L23.4667 24.4667L25.1333 5.33334H16Z",
    fill: "#FF6D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.6667V14H21.7333L21.2667 21.6667L16 23.4V20.6L18.7333 19.6667L18.9333 16.6667H16V16.6667ZM21.9333 11.3333L22.1333 8.66666H16V11.3333H21.9333Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20.6V23.4L10.7333 21.6667L10.4667 18H13.1333L13.2667 19.6667L16 20.6ZM12.7333 11.3333H16V8.66666H9.93333L10.4 16.6667H16V14H12.9333L12.7333 11.3333Z",
    fill: "#EEEEEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3333 3.33331H25.6667L27.6667 26L37 28.6666L46.3333 26L48.3333 3.33331Z",
    fill: "#0277BD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37 5.33334V26.6L44.4667 24.4667L46.1333 5.33334H37Z",
    fill: "#039BE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0667 8.66666H37V11.3333H40.2667L40.0667 14H37V16.6667H39.9333L39.7333 19.6667L37 20.6V23.4L42.2667 21.6667L42.7333 14L43.0667 8.66666Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37 8.66666V11.3333H31.0667L30.8667 8.66666H37ZM33.9333 14L34.0667 16.6667H37V14H33.9333ZM34.2 18H31.5333L31.7333 21.6667L37 23.4V20.6L34.2667 19.6667L34.2 18Z",
    fill: "#EEEEEE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 19.3333H38L35.3333 42L26.6667 44.6666L17.3333 42L15.3333 19.3333Z",
    fill: "#E7A42B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7533 21.3333L33.5 40.4733L26.6667 42.5733V21.3333H35.7533Z",
    fill: "#F2BF22"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 30L27.3333 31.3333L26.6667 32.6667H20.5267L21.0933 24H26.6667L27.3333 25.3333L26.6667 26.6667H24.02L23.8 30H26.6667Z",
    fill: "#FAF9F8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 37.7133L26.6667 37.6933L27.3333 39.3333L26.6667 40.48L26.6267 40.4933L21.0733 38.9067L20.7 34.6667H23.38L23.5667 36.8467L26.6 37.7133Z",
    fill: "#EBEBEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7133 30L31.6667 38.9467L26.6667 40.48V37.6933L29.22 36.9067L29.7133 32.6667H26.6667V30H32.7133Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.28 28H30.62L30.4467 26.6667H26.6667V24H32.7533L32.8667 24.84L33.28 28Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlCssJs);
export default __webpack_public_path__ + "static/media/html-css-js.322626ffeb759fb2a054e3db38d68b35.svg";
export { ForwardRef as ReactComponent };